export const checkDomainName = (domain, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'get',
    apiPath: `domain/${domain}`,
    cancelToken
  })
)
